function locationInDocument(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
/**
 *
 * @param {DOM Element} element
 * @param {Percentage} offset
 */
export default function isElementInViewport(element, offset = 0) {
    const eleTop = locationInDocument(element).top;
    const eleHeight = element.clientHeight;
    const windowTop = window.pageYOffset;

    const topOfElement = eleTop + offset * eleHeight;
    const bottomOfElement = eleTop + eleHeight;
    const bottomOfScreen = windowTop + window.innerHeight;
    const topOfScreen = windowTop;

    if (bottomOfScreen > topOfElement && topOfScreen < bottomOfElement) {
        // the element is visible, do something
        return true;
    }
    return false;
}
